import { render, staticRenderFns } from "./data16.vue?vue&type=template&id=0976855a&scoped=true&"
import script from "./data16.vue?vue&type=script&lang=js&"
export * from "./data16.vue?vue&type=script&lang=js&"
import style1 from "./data16.vue?vue&type=style&index=1&id=0976855a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976855a",
  null
  
)

export default component.exports